export default __webpack_public_path__ + "static/media/wwr-subImg2.080e91f8.webp";